import React from 'react';
import './index.css';

export default function Main() {
  return (
    <div className='main-container'>
      <div className='rectangle' />
      <div className='flex-column-dd'>
        <div className='frame'>
          <div className='frame-1'>
            <div className='frame-2'>
              <span className='change-the-life'>
                Change the life Change the world
              </span>
              <div className='frame-3'>
                <span className='every-good-act'>
                  Every Good Act is A Charity
                </span>
                <span className='tacking-poverty-communities'>
                  We,ve been tacking poverty in communities to build better
                  lives
                </span>
              </div>
            </div>
            <div className='frame-4'>
              <div className='frame-5'>
                <div className='checks'>
                  <div className='group' />
                </div>
                <span className='how-we-help'>How we Help</span>
              </div>
              <div className='frame-6'>
                <div className='checks-7'>
                  <div className='group-8' />
                </div>
                <span className='support-us'>Support us</span>
              </div>
            </div>
          </div>
          <div className='frame-9' />
        </div>
        <div className='frame-a'>
          <div className='frame-b'>
            <span className='begin-giving-to-them'>BEGIN GIVING TO THEM</span>
            <span className='explore-these-causes'>Explore These Causes</span>
          </div>
          <div className='frame-c'>
            <div className='frame-d'>
              <div className='frame-e'>
                <span className='help-us-touch'>
                  Help us touch their lives of these youths
                </span>
                <span className='food-help-touch'>
                  Food Help us touch their lives of these youths There are
                </span>
              </div>
              <div className='frame-f'>
                <div className='frame-10'>
                  <div className='frame-11' />
                </div>
                <div className='frame-12'>
                  <span className='help-us-touch-13'>
                    Help us touch their lives of these youths
                  </span>
                  <span className='food-help-touch-14'>
                    Food Help us touch their lives of these youths There are
                  </span>
                </div>
                <div className='group-15'>
                  <span className='text-c'>60%</span>
                  <div className='group-16'>
                    <div className='frame-17'>
                      <div className='ellipse' />
                    </div>
                    <div className='frame-18' />
                  </div>
                  <div className='frame-19'>
                    <div className='frame-1a'>
                      <span className='raised-amount'>$13,034.00</span>
                      <span className='raised'>Raised</span>
                    </div>
                    <div className='frame-1b'>
                      <span className='raised-amount-1c'>$13,034.00</span>
                      <span className='raised-1d'>Raised</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className='frame-1e'>
                <div className='frame-1f' />
                <div className='image' />
              </div>
              <div className='frame-20'>
                <div className='frame-21'>
                  <span className='charity-22'>Charity</span>
                </div>
              </div>
            </div>
            <div className='frame-23'>
              <div className='frame-24'>
                <span className='help-us-touch-25'>
                  Help us touch their lives of these youths
                </span>
                <span className='food-help-touch-26'>
                  Food Help us touch their lives of these youths There are
                </span>
              </div>
              <div className='frame-27'>
                <div className='frame-28'>
                  <div className='frame-29' />
                </div>
                <div className='frame-2a'>
                  <span className='help-us-touch-2b'>
                    Help us touch their lives of these youths
                  </span>
                  <span className='food-help-us-touch'>
                    Food Help us touch their lives of these youths There are
                  </span>
                </div>
                <div className='group-2c'>
                  <div className='group-2d'>
                    <span className='percentage'>30%</span>
                    <div className='group-2e'>
                      <div className='group-2f'>
                        <div className='frame-30'>
                          <div className='ellipse-31' />
                        </div>
                      </div>
                      <div className='frame-32' />
                    </div>
                  </div>
                  <div className='frame-33'>
                    <div className='frame-34'>
                      <span className='raised-amount-35'>$13,034.00</span>
                      <span className='raised-36'>Raised</span>
                    </div>
                    <div className='frame-37'>
                      <span className='raised-amount-38'>$13,034.00</span>
                      <span className='raised-39'>Raised</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className='frame-3a'>
                <div className='frame-3b' />
                <div className='image-3c' />
                <div className='frame-3d'>
                  <div className='frame-3e' />
                  <div className='overlay' />
                  <div className='flex-row-fce'>
                    <div className='image-3f' />
                    <div className='overlay-40' />
                  </div>
                </div>
              </div>
              <div className='frame-41'>
                <div className='frame-42'>
                  <span className='charity-43'>Charity</span>
                </div>
              </div>
            </div>
            <div className='frame-44'>
              <div className='frame-45'>
                <span className='help-us-touch-46'>
                  Help us touch their lives of these youths
                </span>
                <span className='food-help-us-touch-47'>
                  Food Help us touch their lives of these youths There are
                </span>
              </div>
              <div className='frame-48'>
                <div className='frame-49'>
                  <div className='frame-4a' />
                </div>
                <div className='frame-4b'>
                  <span className='help-us-touch-4c'>
                    Help us touch their lives of these youths
                  </span>
                  <span className='food-help-us-touch-4d'>
                    Food Help us touch their lives of these youths There are
                  </span>
                </div>
                <div className='group-4e'>
                  <div className='group-4f'>
                    <span className='percentage-50'>65%</span>
                    <div className='group-51'>
                      <div className='frame-52'>
                        <div className='ellipse-53' />
                      </div>
                      <div className='frame-54' />
                    </div>
                  </div>
                  <div className='frame-55'>
                    <div className='frame-56'>
                      <span className='raised-amount-57'>$13,034.00</span>
                      <span className='raised-58'>Raised</span>
                    </div>
                    <div className='frame-59'>
                      <span className='raised-amount-5a'>$13,034.00</span>
                      <span className='raised-5b'>Raised</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className='frame-5c'>
                <div className='image-5d' />
                <div className='frame-5e' />
                <div className='image-5f' />
              </div>
              <div className='frame-60'>
                <div className='frame-61'>
                  <span className='charity-62'>Charity</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='frame-63'>
          <div className='frame-64'>
            <div className='frame-65'>
              <span className='links'>Links</span>
              <div className='frame-66'>
                <span className='about-us'>About Us</span>
              </div>
              <div className='frame-67'>
                <span className='faqs'>Faq’s</span>
              </div>
              <div className='frame-68'>
                <span className='events'>Events</span>
              </div>
              <div className='frame-69'>
                <span className='courses'>Courses</span>
              </div>
              <div className='frame-6a'>
                <span className='contact'>Contact</span>
              </div>
            </div>
            <div className='frame-6b'>
              <span className='other-link'>Other Link</span>
              <div className='frame-6c'>
                <span className='about-us-6d'>About Us</span>
              </div>
              <div className='frame-6e'>
                <span className='faqs-6f'>Faq’s</span>
              </div>
              <div className='frame-70'>
                <span className='events-71'>Events</span>
              </div>
              <div className='frame-72'>
                <span className='courses-73'>Courses</span>
              </div>
              <div className='frame-74'>
                <span className='contact-75'>Contact</span>
              </div>
            </div>
            <div className='frame-76'>
              <span className='newsletter'>Newsletter</span>
              <div className='frame-77'>
                <span className='about-us-78'>About Us</span>
              </div>
              <div className='frame-79'>
                <span className='faqs-7a'>Faq’s</span>
              </div>
              <div className='frame-7b'>
                <span className='events-7c'>Events</span>
              </div>
              <div className='frame-7d'>
                <span className='courses-7e'>Courses</span>
              </div>
              <div className='frame-7f'>
                <span className='contact-80'>Contact</span>
              </div>
            </div>
          </div>
          <div className='layer' />
        </div>
        <div className='rectangle-81' />
        <div className='rectangle-82' />
        <div className='frame-83'>
          <div className='flex-row-aed'>
            <div className='rectangle-84'>
              <div className='layer-85' />
            </div>
            <div className='frame-86'>
              <div className='frame-87'>
                <span className='namaz-timing'>Namaz Timing</span>
                <div className='clock' />
              </div>
            </div>
            <div className='frame-88'>
              <div className='frame-89'>
                <span className='home'>Home</span>
              </div>
              <div className='frame-8a'>
                <span className='features'>Features</span>
                <div className='chevron-down'>
                  <div className='icon' />
                </div>
              </div>
              <div className='frame-8b'>
                <span className='events-8c'>Events</span>
                <div className='chevron-down-8d'>
                  <div className='icon-8e' />
                </div>
              </div>
              <div className='frame-8f'>
                <span className='charity-90'>Charity</span>
              </div>
              <div className='frame-91' />
            </div>
          </div>
          <div className='oval' />
        </div>
        <div className='rectangle-92' />
        <div className='rectangle-93' />
        <div className='rectangle-94' />
        <div className='frame-95'>
          <div className='frame-96'>
            <span className='change-the-life-97'>
              Change the life Change the world
            </span>
            <span className='charity-with-difference'>
              Charity With Difference
            </span>
          </div>
          <div className='frame-98'>
            <div className='frame-99'>
              <div className='frame-9a'>
                <div className='frame-9b'>
                  <div className='charity-9c'>
                    <div className='group-9d'>
                      <div className='group-9e'>
                        <div className='vector' />
                      </div>
                    </div>
                    <div className='group-9f'>
                      <div className='group-a0'>
                        <div className='vector-a1' />
                      </div>
                    </div>
                    <div className='group-a2'>
                      <div className='group-a3'>
                        <div className='vector-a4' />
                      </div>
                    </div>
                  </div>
                  <div className='frame-a5'>
                    <span className='get-inspire-and-help'>
                      Get Inspire And Help
                    </span>
                    <span className='please-donate'>
                      Please donate to change the world if you are inspired by
                      us.
                    </span>
                  </div>
                </div>
                <div className='frame-a6'>
                  <div className='checks-a7'>
                    <div className='group-a8' />
                  </div>
                  <span className='read-more'>Read more</span>
                </div>
              </div>
            </div>
            <div className='frame-a9'>
              <div className='frame-aa'>
                <div className='frame-ab'>
                  <div className='donate' />
                  <div className='frame-ac'>
                    <span className='send-us-donations'>Send Us Donations</span>
                    <span className='join-us-volunteer'>
                      Want to help with this pandemic, please join us as a
                      volunteer.
                    </span>
                  </div>
                </div>
                <div className='frame-ad'>
                  <div className='checks-ae'>
                    <div className='group-af' />
                  </div>
                  <span className='read-more-b0'>Read more</span>
                </div>
              </div>
            </div>
            <div className='frame-b1'>
              <div className='frame-b2'>
                <div className='frame-b3'>
                  <div className='donation' />
                  <div className='frame-b4'>
                    <span className='become-a-volunteer'>
                      Become A Volunteer
                    </span>
                    <span className='creating-donation-event'>
                      Creating a donation event can help us directly or
                      indirectly
                    </span>
                  </div>
                </div>
                <div className='frame-b5'>
                  <div className='checks-b6'>
                    <div className='group-b7' />
                  </div>
                  <span className='read-more-b8'>Read more</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='rectangle-b9' />
        <div className='rectangle-ba' />
        <div className='frame-bb'>
          <div className='frame-bc' />
          <div className='frame-bd'>
            <div className='frame-be'>
              <div className='frame-bf'>
                <span className='help-with-featured-cause'>
                  Help With Featured Cause
                </span>
                <span className='contribute-for-the-differently-abled'>
                  Contribute for the differently abled
                </span>
              </div>
              <span className='the-great-journey'>
                The great journey to end poverty for good begins with a child.
                Due to natural disasters and man made disasters so many people
                are suffering so help to recover them....
              </span>
            </div>
            <div className='frame-c0'>
              <div className='frame-c1'>
                <div className='frame-c2'>
                  <div className='frame-c3' />
                  <div className='frame-c4'>
                    <span className='percentage-c5'>0%</span>
                    <span className='pledged-so-far'>Pledged So Far</span>
                  </div>
                </div>
                <span className='target'>Target: $5,000.00</span>
              </div>
              <div className='frame-c6'>
                <div className='frame-c7'>
                  <div className='checks-c8'>
                    <div className='group-c9' />
                  </div>
                  <span className='donate-now'>Donate now</span>
                </div>
                <div className='frame-ca'>
                  <div className='frame-cb'>
                    <div className='play'>
                      <div className='group-cc' />
                    </div>
                    <span className='cause-video'>Cause vedio</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='ellipse-cd' />
        <div className='rectangle-ce' />
        <div className='rectangle-cf' />
        <div className='frame-d0'>
          <div className='frame-d1'>
            <div className='frame-d2'>
              <div className='image-d3' />
            </div>
            <div className='image-d4' />
          </div>
          <div className='frame-d5'>
            <div className='frame-d6'>
              <div className='frame-d7'>
                <span className='make-a-difference'>
                  MAKE A DIFFERENCE TODAY!
                </span>
                <span className='together'>
                  There's a lot more We can do, together
                </span>
              </div>
              <span className='lorem-ipsum'>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.There
                are many variations of passages of lorem Ipsum available, but
                the majority have suffered alteration dolore magna
              </span>
            </div>
            <div className='frame-d8'>
              <span className='fundraise-now'>FUNDRAISE NOW</span>
            </div>
          </div>
        </div>
        <div className='rectangle-d9' />
        <div className='rectangle-da' />
        <div className='frame-db'>
          <span className='donate-today'>
            Donate Today to Save Children From the Trauma of Abuse
          </span>
          <div className='frame-dc'>
            <div className='frame-dd'>
              <span className='single-donation'>Single donation</span>
            </div>
            <div className='frame-de'>
              <span className='regular-donation'>Regular donation</span>
            </div>
          </div>
        </div>
        <div className='rectangle-df' />
        <div className='rectangle-e0' />
        <div className='rectangle-e1' />
      </div>
      <div className='rectangle-e2' />
    </div>
  );
}
